import { Component, OnInit, TemplateRef, ViewChild, Inject, OnDestroy, HostListener,ElementRef, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Location, DOCUMENT } from '@angular/common';
import { ApiService } from 'src/app/pages/common/api.service';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute,Router, Params } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { CouponModalComponent } from 'src/app/shared/components/coupon-modal/coupon-modal.component';
import * as moment from 'moment';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { NotEligibleModalComponent } from 'src/app/shared/components/not-eligible-modal/not-eligible-modal.component';
import { FacebookPixelService } from 'src/app/facebook-pixel/facebook-pixel.service';
import { PennyDropModalComponent } from 'src/app/shared/components/penny-drop-modal/penny-drop-modal.component';

@Component({
  selector: 'app-offer-detail',
  templateUrl: './offer-detail.component.html',
  styleUrls: ['./offer-detail.component.scss'],
  providers: [ApiService, GlobalConstants, ToastrService]
})

export class OfferDetailComponent implements OnInit,OnDestroy {
  isDisabled = false;
  projectSubscription: Subscription;
  reloadSubscription: Subscription;
  modalRef: BsModalRef;
  pennyDropModalRef: BsModalRef;
  @ViewChild('redeemModal') redeemModal: TemplateRef<any>;
  // @ViewChild(HeaderComponent) headC: HeaderComponent;
  public templateNum: number = 1;
  showAuthentication: boolean = false;
  deviceInfo = null;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktopDevice: boolean = false;
  public isPreview: boolean = false;
  merchant_id: any;
  offers: any = [];
  selectedOffer: any;
  openedOffer: number = 0;
  public resendingVoucher: boolean = false;
  registerForm: UntypedFormGroup;
  public offerNum: number;
  allOffers: any;
  copiedCode: boolean;
  merchantDescOpen: boolean;
  is_loading: boolean = true;
  openTerm: boolean = false;
  isReSending: any = { id: 0, state: 'initial' };
  isload2: boolean;
  binError: boolean;
  showBinEnterPop: boolean = false;
  showCouponPop: boolean = false;
  openedInSlide: string = 'terms';
  authenticated_user: any = false;
  client: any;
  bundleContext: any;
  isNearby: boolean = false;
  isInternational: boolean = false;
  redeemActive: boolean = false;
  showIfNotAuthenticated: any;
  applicableTag = '';
  offerToRedeem: any;
  environment_type: any;
  currentProject: any;
  resendText = 'Resend Voucher';
  public isTimesPrime: boolean = false;
  public vouchers: Array<{
    code: string
    id: string
    status: string
    voucher_end_date: string
  }> = [];
  public fetchingRedeemedVoucher: boolean = false;

  @HostListener('unloaded')
  ngOnDestroy() {
    if(this.projectSubscription){
      this.projectSubscription.unsubscribe()
    }
    if(this.reloadSubscription){
      this.reloadSubscription.unsubscribe()
    }
    this.elementRef.nativeElement.remove();
  }
  removeSubscriptions(){
    if(this.projectSubscription){
      this.projectSubscription.unsubscribe()
    }
    if(this.reloadSubscription){
      this.reloadSubscription.unsubscribe()
    }
  }
  constructor(
    private formBuilder: UntypedFormBuilder,
    private location: Location,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    public GlobalConstants: GlobalConstants,
    public meta: Meta,
    public pageTitle: Title,
    private modalService: BsModalService,
    private _auth: AuthenticationService,
    private toastr: ToastrService,
    private dataTransferService: DataTransferService,
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private elementRef: ElementRef,
    private _renderer2: Renderer2,
    private fpService: FacebookPixelService
  ) {
    this.deviceCheckFunction();

  }
  deviceCheckFunction() {
    // this.deviceInfo = this.deviceService.getDeviceInfo();
    // this.isMobile = this.deviceService.isMobile();
    // this.isTablet = this.deviceService.isTablet();
    // this.isDesktopDevice = this.deviceService.isDesktop();
  }
  seo(offer) {
    var title = offer?.data?.merchant?.name + ' - ' + this.GlobalConstants.data.titles.homepage_pagetitle;
    this.pageTitle.setTitle(title);
    this.meta.addTags([
      { name: 'description', content: this.GlobalConstants.data.titles.homepage_description },
      { name: 'keywords', content: this.GlobalConstants.data.titles.homepage_keywords }
    ]);
  }
  backClicked() {
    this.location.back();
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'showTermsModal' }); //,backdrop: 'static'
    //this.modalRef.hide();
  }

  ngOnInit() {
    this.isTimesPrime = this.document.location.pathname.includes('visa-times-prime');
    this.fpService.load();
    document.getElementById('top-section').scrollIntoView({ block: 'start' });
    // if(this.document.location.pathname.includes('blinkit-formerly-grofers')){
    //   this.isDisabled = true;
    // }
    // if(!this.projectSubscription) {
      this.checkRoutes()
    // }
      this.checkAuth()
      // this.removeSubscriptions();
      if(!this.reloadSubscription){
        this.reloadSubscription = this.dataTransferService.sharedReloadEvent.subscribe(res => {
          if(res){
            console.log('reload detail')
            this.merchantData = '';
            this.checkRoutes();
            this.checkAuth();
          }
        });
      }
  }
  checkAuth(){
    if (localStorage.getItem("currentUser")) {
      this.authenticated_user = true;
    }
  }
  merchantData = '';
  checkRoutes(){
    this.route.params.subscribe(
      params => {
        if(this.projectSubscription){
          this.projectSubscription.unsubscribe()
        }
          this.projectSubscription = this.dataTransferService.sharedMessage.subscribe(result => {
            if(result && result.id){
              if(params.code && this.merchantData !== params.code){
                  this.merchantData = params.code;
                  this.is_loading = true;
                  let projectData = result;
                  if(projectData && projectData.sub_projects && projectData.sub_projects.data){
                    this.getSpecialOffers(params.code, projectData.sub_projects.data);
                  }
              }
              else if(params.merchant_id && this.merchantData !== params.merchant_id){
                this.merchantData = params.merchant_id;
                this.environment_type = this.document.location.hostname.includes("sandbox") ? 'sandbox' : 'prod';
                localStorage.setItem("projectId", this.GlobalConstants.data.x_header[this.environment_type].main_project);
                this.merchant_id = params.merchant_id;
                this.currentProject = result;
                this.getOffers(params.merchant_id);
              }
            }

          });
        // }

      });
  }
  changeOfferStatus(offer) {
    if (this.offers && this.offers.data) {
      let reqOff = this.offers.data.find((x) => { return x.id === offer.id })
      if (reqOff && reqOff.attributes) {
        reqOff.attributes.claimable = false;
      }
    }
  }


  reloadInit() {
    this.ngOnInit();
  }

  selectOffer(offer, merchant = null) {
    this.selectedOffer = offer;
    if (merchant != null) {
      this.selectedOffer.merchant = merchant;
    }
  }
  couponLoading: boolean = true;
  redeemOffer(offer, revalidate?) {
    this.fpService.claimOfferClicked();
    if (localStorage.getItem("currentUser")) {
      if(revalidate){
        let merchantOffer = this.offers.data.find((x) => { return x.id === offer.id })
        if(merchantOffer && merchantOffer.id){
          offer = merchantOffer;
        }
      }
      if(offer.attributes.claimable_by_country){
        this.selectedOffer = offer;
        if(offer?.attributes?.claimable) {
          this.modalRef = this.modalService.show(CouponModalComponent, Object.assign({}, { class: 'redeem-coupon modal-lg modal-dialog-centered' }, {
            initialState: {
              selectedOffer: this.processSelectedOffer(this.selectedOffer)
            }
          }));
          this.modalRef.content.redeemResponseEvent.subscribe(res => {
            if(res.response && res.response){
              if(res.response == 'success'){
                this.changeOfferStatus(this.selectedOffer);
                this.getVoucherCodeIfRedeemed()
              }
              else if(res.response == 'payment-needed'){
                localStorage.setItem("offerToRedeem", JSON.stringify(this.selectedOffer));
              }
            }
          })
        }
      }
      else{
        this.showNotEligible();
      }
    } else {
      this.offerToRedeem = offer;
      this._auth.errorEvent.emit(true);
    }
  }


  processSelectedOffer(offer) {
    return {
      id: offer.id,
      merchantLogoUrl: this.offers.data.merchant.logo_url,
      offerType: offer.attributes.offer_type,
      endDate: offer.attributes.end_date,
      offerTitle: offer.attributes.title,
      merchantName: this.offers.data.merchant.name,
      redemptionUrl: offer.attributes.redemption_url != null ? offer.attributes.redemption_url : this.offers.data.merchant.website,
      pva: this.currentProject.pva
    }
  }
  resendCode(id: string){
    if(!this.isTimesPrime) {
      if(this.resendingVoucher) return;
      this.resendingVoucher = true;
    } else {
      this.resendText = "Resending ..."
    }
    this._apiService.resendVoucher(id).subscribe({
      next: (res: any) => {
        if(res?.success && !this.isTimesPrime) {
          this.toastr.success("Voucher Resent");
          this.resendingVoucher = false;
        } else {
          this.resendText = "Voucher Resent"
        }
      },
      error: () => {
        this.toastr.error('Something went wrong. Please try again!');
        this.resendText = "Resend Voucher";
        this.resendingVoucher = false;
      }
    });
  }

  getVoucherCodeIfRedeemed(offer?) {
    this.fetchingRedeemedVoucher = true;
    this._apiService.getRedemptions({ offer: true }).subscribe({
      next: (response: any) => {
        if(!response?.data.length) {
          throw new Error("Redemptions empty")
          //Unable to get the voucher.
        }
        const timesPrimeRedemption = response.data[0];
        this.vouchers[timesPrimeRedemption?.attributes?.offer?.id] = timesPrimeRedemption?.attributes?.voucher;
        this.fetchingRedeemedVoucher = false;
      }, 
      error: (error: any) => {
        this.fetchingRedeemedVoucher = false;
        console.log(error);
      }
    })
  }

  copy(code) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = code;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.success('Copied','', {
      timeOut: 4000,
    });
  }

  getOffers(merchant_id) {
    var data = {
      merchant_id: merchant_id
    }

    this._apiService.getOffers(data).subscribe(
      (res: any) => {
        if (res.data.length == 0) {
          // this.showNotEligible();
          // if (this.authenticated_user) {
            this.showNotEligible();
            // setTimeout(()=>{
            //   window.location.href = "/";
            //   return false;
            //  }, 2000);
          // }
          // else{
          //   window.location.href = "/";
          //   return false;
          // }
        }
        this.offers = res;
        
        if(this.offers.data.length > 1){
          this.sortOffers(this.offers.data);
        }

        this.offers.included.forEach(obj => {
          if (obj.type == 'merchant') {
            this.offers.data.merchant = obj.attributes;
            this.offers.data.merchant.id = obj.id;
          }
        })
        this.is_loading = false
        this.seo(this.offers);
        if (this.authenticated_user) {
          this.checkOfferToRedeem();
          this.route.queryParams.subscribe(params => {
            let offer_id = params['offer_id'];
            let terms = params['terms'];

            if (offer_id) {
              var count = 0;
              this.offers.data.forEach(offer => {
                if (offer.id == offer_id) {
                  this.selectedOffer = this.offers.data[count];
                  count = count + 1;
                }

              })

              if (!this.isMobile) {
                this.openTerm = true;
                this.modalRef = this.modalService.show(this.redeemModal, { class: 'offer-bundle-success-modal' });
              }
              else {
                this.sideMenuOpen = true;
              }
            }

            if (terms) {
            }
          })
        }

      },
      (err) => {
      }
    );
  }
  sortOffers(offers){
      offers.sort(function (a, b) {
        var textA = moment(a.attributes.updated_at);
        var textB = moment(b.attributes.updated_at);
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        return (textA.diff(textB) < 0) ? -1 : (textA.diff(textB) > 0) ? 1 : 0;
    })
  }
  getSpecialOffers(code,specialProjects){
    let pathname = this.document.location.pathname.split('/',3);
    var selectedProject;
    if(pathname.length == 3 && pathname[2] == 'offers'){
      let selectedProjectCode = pathname[1];
      specialProjects.forEach(obj => {
        if(obj.attributes.code === selectedProjectCode){
          selectedProject = obj.attributes;
          this.currentProject = selectedProject;
          localStorage.setItem("projectId", obj.id);
        }
      })
    }

    if(selectedProject){
      let merchant = selectedProject.merchants.find((x) => { return x.code === code })
      if(merchant && merchant.id){
        this.merchant_id = merchant.id;
        this.getOffers(this.merchant_id);
      }

    }
    else{
      this.showNotEligible();
      // setTimeout(()=>{
        // debugger;
        // window.location.href = "/";
        // return false;
      //  }, 2000);
      // return false;
    }
  }
  checkOfferToRedeem(){
    this.route.queryParams.subscribe(params => {
      if(params && params['payment_verified'] && params['payment_verified'] == 'true' && localStorage.getItem("offerToRedeem")){
        this.offerToRedeem = JSON.parse(localStorage.getItem("offerToRedeem"));
        localStorage.removeItem('offerToRedeem');
        let qParams: Params = {};
        this.setQueryParams(qParams)
      } else if(params?.payment_verified === 'false') {
        this.pennyDropModalRef = this.modalService.show(PennyDropModalComponent, Object.assign({}, { class: 'penny-drop-modal modal-lg modal-dialog-centered'}));
        let qParams: Params = {};
        this.setQueryParams(qParams);
      }
      else if(this.isTimesPrime && this.authenticated_user){
        this.offers?.data?.map((offer) => this.getVoucherCodeIfRedeemed(offer))
      }
    });
      if (this.offerToRedeem) {
        this.redeemOffer(this.offerToRedeem, true);
        this.offerToRedeem = null;
      }
  }
  setQueryParams(qParams){
    this.router.navigate([], {
        relativeTo: this.route,
        queryParams: qParams,
        queryParamsHandling: ''
    });
  }
  sideMenuOpen: any = false;
  offerToCheck: any;
  redeemCardCheck(offer) {
    this.showBinEnterPop = true;
    this.offerToCheck = offer;
  }
  hideAuthentication() {
    this.showAuthentication = false;
  }

  checkLength(content) {
    return content.replace(/<[^>]*>/g, '').length;
  }
  redeeming: boolean = false;
  goTo(selectedOfr) {
    this.redeeming = true;
    let gotourl = selectedOfr.attributes.redemption_url != null ? selectedOfr.attributes.redemption_url : this.offers.included[1].attributes.website;
    setTimeout(() => {
      window.open(gotourl, '_blank');
      this.redeeming = false;
      this.redeemActive = false;
    }, 0)

  }


  showNotEligible() {
    this.modalService.show(NotEligibleModalComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'not-eligible-modal'
    });
  }
  showCopied() {
    this.toastr.success('Copied!');
  }

}
